import TaskPreview from './TaskPreview';
import ImagePreview from './ImagePreview';

export default {
    text: TaskPreview,
    image: ImagePreview
}